module.exports = __webpack_public_path__ + "static/media/9.d8ecf205.JPG";